import { UpdateProposalRequestDto } from '@modules/proposals/api/dto/updateProposal.dto';
import { legacyTypes } from '@modules/proposals/api/mappers/legacyTypes';
import { ProposalCreationClientAndMortgageForm } from '../types';

export const mapProposalClientDetailsFormToRequest = (
  data: ProposalCreationClientAndMortgageForm
): UpdateProposalRequestDto['client'] => ({
  first_name: data.client_details.first_name,
  last_name: data.client_details.last_name,
  residency_status: data.client_details.citizen_status
    ? legacyTypes.residencyType[data.client_details.citizen_status] : undefined,
  employment_status: data.client_details.employment_status
    ? legacyTypes.employmentType[data.client_details.employment_status] : undefined,
});
